const hostname = window.location.hostname;
const isDevelopment = hostname === "localhost" || hostname.includes("vuca-dev.simbaanalytics-dev.rio.cloud");
const isProduction = hostname.includes("vuca-prod.simbaanalytics-prod.rio.cloud");

const authConfig = {
    cognitoDomain: isDevelopment
        ? "eu-west-1fhushs9n4.auth.eu-west-1.amazoncognito.com" // Replace with actual Dev Cognito Domain
        : isProduction
        ? "eu-west-1alu2rcppg.auth.eu-west-1.amazoncognito.com" // Replace with actual Prod Cognito Domain
        : "default-cognito-domain.auth.eu-west-1.amazoncognito.com", // Fallback Cognito Domain

    clientId: isDevelopment
        ? "7b87s0lq8dae3s04t52se3ecso" // Replace with actual Dev Client ID
        : isProduction
        ? "6ip1i6cuihqs2g5tqavig2p9ii" // Replace with actual Prod Client ID
        : "DEFAULT_CLIENT_ID", // Fallback Client ID

    redirectUri: isDevelopment
        ? "https://vuca-dev.simbaanalytics-dev.rio.cloud/" // Replace with actual Dev Redirect URIss
        : isProduction
        ? "https://vuca-prod.simbaanalytics-prod.rio.cloud/"
        : "", // Fallback URL

    responseType: "code",
    scope: "openid phone email",
};

export default authConfig;